/**
 * "Open in the Bundle app" from a browser: hands a page to the installed desktop app through its `bundle://` scheme
 * (apps/desktop/INTEGRATION.md §4: `bundle://m/<code>` opens a meeting's own window). Nothing tells a page whether
 * the app is installed, so the button sits next to a download link.
 */
import { isDesktop } from "./desktop.ts";

export const DESKTOP_DOWNLOAD_URL = "https://bundle.direct/download";

type UaData = { mobile: boolean; platform: string };

/**
 * A browser on a Mac or Windows computer: not a phone or tablet, and not the app itself. Linux is left out: the Linux
 * app has no WebRTC, so it sends calls back to the browser anyway.
 */
export function canOpenInDesktopApp(): boolean {
  if (isDesktop() || typeof navigator === "undefined") return false;
  const uaData = (navigator as Navigator & { userAgentData?: UaData }).userAgentData;
  if (uaData !== undefined) return !uaData.mobile && (uaData.platform === "macOS" || uaData.platform === "Windows");
  const ua = navigator.userAgent;
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return false;
  // iPadOS Safari reports itself as a Mac; only the touch points give it away.
  if (/Macintosh/.test(ua)) return navigator.maxTouchPoints <= 1;
  return /Windows/.test(ua);
}

/** Opens an in-app route (`/m/<code>`) in the desktop app: `bundle://m/<code>`. */
export function openInDesktopApp(path: string): void {
  location.href = `bundle:/${path.startsWith("/") ? path : `/${path}`}`;
}
